import * as React from 'react';
import * as ReactDOM from 'react-dom';

export enum PortalSelectors {
  tooltips = '#tooltips',
  modal = '#modal',
}

export type PortalProps = {
  children?: React.ReactNode;
  portalSelector: PortalSelectors | null;
};

const Portal: React.FC<PortalProps> = ({ children, portalSelector }: PortalProps) => {
  React.useEffect(() => {
    if (portalSelector) {
      const elementId = portalSelector.slice(1);
      if (!document.getElementById(elementId)) {
        const el = document.createElement('div');
        el.setAttribute('id', elementId);

        document.body.prepend(el);
      }
    }
  }, [portalSelector]);

  const container = React.useMemo(() => portalSelector && document.querySelector(portalSelector), [portalSelector]);

  return container ? ReactDOM.createPortal(children, container) : <>{children}</>;
};

export default Portal;
